import './accordion.scss'
import { AccordionItem } from './AccordionItem'
import { useState } from 'react'

interface AccordionData {
  key: string
  title: string
  content: string
}
interface AccordionProps {
  data: AccordionData[]
}

export const Accordion: React.FC<AccordionProps> = ({ data, ...props }) => {
  const [expandedIndex, setExpandedIndex] = useState(-1)
  const toggle = (index: number) => {
    if (expandedIndex === index) {
      setExpandedIndex(-1)
    } else {
      setExpandedIndex(index)
    }
  }
  return (
    <div className="accordion">
      {
        data.map((faq, index) => (
          <AccordionItem key={faq.key} open={index === expandedIndex} title={faq.title} content={faq.content} onToggle={() => toggle(index)} />
        ))
      }
    </div>
  )
}